import { commonChartOptions } from './commonChartOptions';
import currencyFormatter from '@/core/filters/formatCurrency';

export const useYAxisForDataType = {
  'currency': {
    axisName: 'amount-axis',
    tooltip: {
      pointFormatter() {
        return `${this.series.name}: ${currencyFormatter(this.y, undefined, 3)}`;
      },
    }
  },
  'count': {
    axisName: 'count-axis',
    tooltip: {
      pointFormat: '{series.name}:{point.y:.0f}'
    }
  }
};

export const defaultColumnChartOptions = Object.assign({}, commonChartOptions, {
  plotOptions: {
    column: {
      stacking: 'normal',
      minPointLength: 3
    },
  },
  xAxis: [{
    id: 'group-axis',
    title: {
      text: ''
    },
    type: 'category',
    crosshair: true,
    labels: {
      useHTML: true,
      formatter() {
        let styleClass ='';
        
        if (this.chart.series[0].data.length > 10 && this.isFirst && !this.isLast) {
          styleClass = 'highcharts-xaxis-label-custom--first';
        }

        return `<span class="${styleClass} highcharts-xaxis-label-custom" title="${this.value}">${this.value}</span>`;
      },
    }
  }],
  yAxis: [
    {
      id: 'amount-axis',
      title: {
        text: 'Amount'
      },
      labels: {
        formatter() {
          return currencyFormatter(this.value, undefined, 0);
        }
      }
    },
    {
      id: 'count-axis',
      title: {
        text: 'Count'
      },
      opposite: true,
    },
  ],
});